module.exports = __webpack_public_path__ + "img/香河家具.e896fbb8.jpg";